export default __webpack_public_path__ + "static/media/fallbackVideo.e93be79e.mp4";